import { useCallback } from "react"
import { Logger } from "../../../../../lib/logging"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { proceedWithOnboarding } from "./SupplierAdminPOSApi"
import { useSnackbar } from "notistack"

export function useHostedOnboarding(agreementId: number) {
    const { enqueueSnackbar } = useSnackbar()

    const { mutateAsync: callProceedWithOnboarding } = useApiMutation(proceedWithOnboarding, {
        async onSuccess(_params, data, _context) {
            const logger = new Logger("acquiring")
            const { agreement } = data

            if (agreement.adyenAgreement?.actionDetails?.externalUrl) {
                const externalUrl = agreement.adyenAgreement.actionDetails.externalUrl
                logger.info(`Redirecting to: ${externalUrl}`)
                window.location.href = externalUrl
            } else {
                enqueueSnackbar({
                    variant: "error",
                    message: "Did not receive hosted onboarding URL from API",
                })
            }
        },
    })

    const handleHostedOnboarding = useCallback(async () => {
        await callProceedWithOnboarding({ agreementId })
    }, [agreementId, callProceedWithOnboarding])

    return {
        handleHostedOnboarding,
    }
}
